import { createFileRoute } from '@tanstack/react-router'
import { BannedCustomersPage } from '~/components/routes/customers/banned-customers-page'
import { bannedCustomersSearchSchema } from '~/components/routes/customers/banned-customers-search'
import { USERS_SCREEN_PERMISSIONS } from '~/components/routes/users/screens'
import { withRoutePermissions } from '~/utils/rbac'

/**
 * Écran « Clients bannis » (kanban #870) — l'ancien onglet « Défauts de paiement », même garde
 * (`read users.payment-defaults.default`), même URL pour les liens et favoris existants.
 */
export const Route = createFileRoute('/_authenticated/users/payment-defaults')({
  staticData: {
    permission: USERS_SCREEN_PERMISSIONS['payment-defaults'],
  },
  validateSearch: bannedCustomersSearchSchema,
  component: BannedCustomersPage,
})
withRoutePermissions(Route)
